
<template>
  <div
    class="courseDetailsVideo"
    :class="{ isIosxVideoOut: isIosx, noAppNav: !isToken }"
  >
    <div v-if="loaded">
      <div v-if="isPower">
        <van-sticky offset-top="0">
          <div class="courseDetailsVideoTop">
            <div class="courseDetailsVideoNav" v-if="!isshowRate">
              <img
                class="navLeft"
                @click="prev()"
                src="./../../../assets/school/backb.png"
              />
              <div class="navRight" v-if="isToken">
                <img
                  class="kj"
                  v-if="data.resources && data.resources.length > 0"
                  src="./../../../assets/school/kjzh1.png"
                  @click="showDownload = true"
                />
                <img
                  src="./../../../assets/school/collect4.png"
                  v-if="!data.is_collection && channel != 1"
                  @click="collect(true, data.id)"
                />
                <img
                  src="./../../../assets/school/collect5.png"
                  v-if="data.is_collection && channel != 1"
                  @click="collect(false, data.id)"
                />
                <img
                  class="sf"
                  src="./../../../assets/school/sfb.png"
                  @click="share()"
                />
              </div>
            </div>
            <Video
              v-if="data.id"
              :src="data.playUrl"
              :id="data.id"
              @suspend="suspend"
              @joinStudy="joinStudy"
              @showRate="showRate"
              @hideRate="hideRate"
              :isAddStudyCenter="data.is_join_study"
              :shootTime="data.breakpoint"
              :trySeeTime="data.try_see"
              ref="Videozj"
            ></Video>
          </div>
        </van-sticky>
        <div>
          <div class="titleTop">
            <h3>{{ data.title }}</h3>
            <p>{{ data.total_study_num }}次学习</p>
          </div>
          <!-- 阴影 -->
          <div style="height: 10px; background: #f7f8fc"></div>
          <van-tabs
            v-model="active"
            scrollspy
            sticky
            line-width="16px"
            line-height="4px"
            title-inactive-color="#6E727A"
            title-active-color="#404247"
            :offset-top="offsetTop"
          >
            <van-tab title="简介">
              <div class="dec">
                <!-- 已加入学习中心 -->
                <div
                  class="joinStudyZl"
                  v-if="channel == 1 && data.is_join_study"
                >
                  <h3>所属专栏</h3>
                  <van-tabs
                    v-model="catalogueActive"
                    line-width="0"
                    swipe-threshold="1"
                    title-active-color="#4E7DF7"
                    title-inactive-color="#6E727A"
                    @change="toOtherCourse"
                  >
                    <van-tab
                      v-for="(item, index) in catalogueList"
                      :key="index"
                    >
                      <template #title>
                        <div class="joinStudyZlItem">
                          <div>
                            <img
                              src="./../../../assets/school/unselected2.png"
                              v-if="item.type == 2"
                            />
                            <img
                              src="./../../../assets/school/unselected3.png"
                              v-if="item.type == 3"
                            />
                            <img
                              src="./../../../assets/school/unselected4.png"
                              v-if="item.type == 4"
                            />
                            <span>{{ item.sort_num }}</span>
                          </div>
                          <p>{{ item.title }}</p>
                        </div>
                      </template>
                    </van-tab>
                  </van-tabs>
                </div>
                <!-- 阴影 -->
                <div
                  style="height: 10px; background: #f7f8fc"
                  v-if="channel == 1 && data.is_join_study"
                ></div>
                <!-- ad -->
                <div
                  class="ad"
                  v-if="data.is_ad == 1 && data.ad_params.status != -1"
                >
                  <img
                    :src="data.ad_params.img_url"
                    @click="adSkip(data.ad_params)"
                  />
                </div>
                <div class="decMid">
                  <div v-html="data.desc" id="content"></div>
                </div>
                <div class="decBom">
                  <!-- 讲师信息 -->
                  <div
                    class="lecturerInfo"
                    v-if="data.lecturer"
                    @click="toLecturerDetail(data.lecturer.id)"
                  >
                    <img
                      class="head_pic"
                      v-if="data.lecturer.head_pic"
                      :src="data.lecturer.head_pic"
                    />
                    <img
                      class="head_pic"
                      v-else
                      src="./../../../assets/school/defaultAvatar.png"
                    />
                    <div class="lecturerInfoMid">
                      <h3>{{ data.lecturer.name }}</h3>
                      <p>{{ data.lecturer.desc }}</p>
                    </div>
                    <div
                      @click.stop="attention(data.lecturer.id)"
                      v-if="!data.is_fans && isToken"
                      class="lecturerInfoAttention"
                    >
                      <img src="./../../../assets/school/add.png" />
                      <span>关注</span>
                    </div>
                    <img
                      v-else
                      src="./../../../assets/school/right.png"
                      style="width: 12px; height: 12px"
                    />
                  </div>
                  <!-- 阴影 -->
                  <div
                    style="height: 10px; background: #f7f8fc; margin-top: 24px"
                  ></div>
                  <!-- 专栏 -->
                  <div
                    class="zl"
                    v-if="
                      (channel == 2 || (channel == 1 && !data.is_join_study)) &&
                      data.special_column
                    "
                    @click="toSpecial(data.special_column.id)"
                  >
                    <h3>所属专栏</h3>
                    <div>
                      <img :src="data.special_column.image" alt="" />
                      <p>{{ data.special_column.title }}</p>
                    </div>
                  </div>
                  <!-- 阴影 -->
                  <div
                    style="height: 10px; background: #f7f8fc"
                    v-if="data.special_column"
                  ></div>
                </div>
              </div>
            </van-tab>
            <van-tab title="评价">
              <CommentList
                :id="id"
                :data="data"
                v-if="id"
                @refresh="getData"
              ></CommentList>
            </van-tab>
          </van-tabs>
          <div class="btmdiv" v-if="!data.is_join_study && isToken">
            <span @click="joinStudy()">加入学习</span>
          </div>
        </div>
      </div>
      <!-- 无权限 -->
      <div v-else>
        <van-sticky offset-top="0">
          <div class="courseDetailsVideoTop courseDetailsVideoTopNoData">
            <div class="courseDetailsVideoNav">
              <img
                class="navLeft"
                @click="prev()"
                src="./../../../assets/school/backh.png"
              />
            </div>
          </div>
        </van-sticky>
        <div class="noPower">
          <img src="./../../../assets/school/dataTip.png" />
          <p>课程数据丢失</p>
        </div>
      </div>
    </div>
    <div v-else class="nodata">
      <van-sticky offset-top="0">
        <div class="courseDetailsVideoTop courseDetailsVideoTopNoData">
          <div class="courseDetailsVideoNav">
            <img
              class="navLeft"
              @click="prev()"
              src="./../../../assets/school/backh.png"
            />
          </div>
        </div>
      </van-sticky>
      <div class="loading">
        <img src="./../../../assets/school/loading.gif" />
        <p>加载中</p>
      </div>
    </div>

    <van-popup v-model="showDownload" closeable round position="bottom">
      <div class="downloadOut">
        <h3>查看课件</h3>
        <div
          class="downloadItem"
          v-for="(item, index) in data.resources"
          :key="index"
        >
          <img
            src="./../../../assets/school/word@2x.png"
            v-if="item.url.substr(-3) == 'doc' || item.url.substr(-4) == 'docx'"
          />
          <img
            src="./../../../assets/school/xls@2x.png"
            v-if="item.url.substr(-3) == 'xls' || item.url.substr(-4) == 'xlsx'"
          />
          <img
            src="./../../../assets/school/ppt@2x.png"
            v-if="item.url.substr(-3) == 'ppt' || item.url.substr(-4) == 'pptx'"
          />
          <img
            src="./../../../assets/school/pdf@2x.png"
            v-if="item.url.substr(-3) == 'pdf'"
          />
          <img
            src="./../../../assets/school/picture.png"
            v-if="
              item.url.substr(-3) == 'jpg' ||
              item.url.substr(-4) == 'jpeg' ||
              item.url.substr(-3) == 'png'
            "
          />
          <p>{{ item.filename }}</p>
          <span @click="fileView(item.url, item.filename)">预览</span>
        </div>
      </div>
    </van-popup>
    <img
      src="./../../../assets/school/goHome.png"
      class="goHome"
      v-if="channel == 1 && isToken"
      @click="goHome()"
    />
    <SfBtm :mobile="mobile" v-if="!isToken && mobile"></SfBtm>
    <span class="shareTip" v-if="!isToken && mobile"
      >{{ mobile.substring(0, 3) + "****" + mobile.substring(7) }}的分享</span
    >
  </div>
</template>

<script>
import Video from "./../components/video.vue";
import CommentList from "./../components/commentList.vue";
import SfBtm from "./../components/sfBtm.vue";
let Base64 = require("js-base64").Base64;
export default {
  data() {
    return {
      isIosx: false,
      loaded: false,
      id: "",
      courseDetailUrl: "school/index/course/detail",
      catalogueUrl: "school/index/column/courses",
      channel: 1,
      isToken: false,
      data: {},
      active: 0,
      showDownload: false,
      catalogueList: [],
      catalogueActive: 0,
      type: 0,
      isIOS: false,
      isPower: false,
      isshowRate: false,
      offsetTop: "240px",
      mobile: "",
    };
  },
  components: { Video, CommentList, SfBtm },
  mounted() {
    this.isIosx = this.isIphoneX();
    // 判断是否预览返回
    if (
      localStorage.getItem("filePreview") &&
      localStorage.getItem("filePreview") == "true"
    ) {
      this.showDownload = true;
      localStorage.setItem("filePreview", "");
    }
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    if (this.$route.query.channel) {
      this.channel = this.$route.query.channel;
    }
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (JSON.parse(sessionStorage.getItem("token"))) {
      this.isToken = true;
      this.courseDetailUrl = "school/member/course/detail";
      this.catalogueUrl = "school/member/column/courses";
      this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
      this.getMobile();
    } else {
      this.isToken = false;
      this.catalogueUrl = "school/index/column/courses";
      this.courseDetailUrl = "school/index/course/detail";
      var u = navigator.userAgent;
      this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (this.$route.query.mobile) {
        this.mobile = this.$route.query.mobile;
        sessionStorage.setItem("mobile", this.mobile);
      } else {
        this.mobile = sessionStorage.getItem("mobile");
      }
    }
    if (this.isToken) {
      if (this.isIosx) {
        this.offsetTop = "245px";
      } else {
        this.offsetTop = "240px";
      }
    } else {
      this.offsetTop = "217px";
    }
    this.getData();
  },
  methods: {
    prev() {
      this.$router.go(-1);
    },
    goHome() {
      sessionStorage.setItem("active", 0);
      this.$router.push({
        path: "/school/index",
      });
    },
    // 获取课程详情
    getData() {
      this.$api
        .get(this.courseDetailUrl, {
          id: this.id,
          channel: this.channel,
        })
        .then((res) => {
          this.data = res;
          this.isPower = true;
          this.data.playUrl = this.urlEncode(res.file);
          this.loaded = true;
          this.$forceUpdate();
          if (this.channel == 1) {
            this.getCatalogueData(res.parent_id);
          }
          // 改变三方链接地址
          setTimeout(() => {
            this.replayAMethod();
          }, 500);
        })
        .catch((res) => {
          if (res.code == 4000006 || res.code == 4000199) {
            // console.log("无权限访问");
            this.isPower = false;
            this.loaded = true;
          }
        });
    },
    // 视频地址解码
    urlEncode(urlfile) {
      //   'a' => 'ぁ',
      //   'b' => 'ぃ',
      //   'c' => 'ぅ',
      //   "d" => "ぇ",
      //   "e" => "ぉ",
      //   "f" => "か",
      //   "g" => "き",
      //   "h" => "く",
      //   "i" => "け",
      //   "j" => "こ",
      let url = urlfile;
      for (let i = 0; i < url.length; i++) {
        switch (url.charAt(i)) {
          case "ぁ":
            url = url.replace(/ぁ/g, "a");
            break;
          case "ぃ":
            url = url.replace(/ぃ/g, "b");
            break;
          case "ぅ":
            url = url.replace(/ぅ/g, "c");
            break;
          case "ぇ":
            url = url.replace(/ぇ/g, "d");
            break;
          case "ぉ":
            url = url.replace(/ぉ/g, "e");
            break;
          case "か":
            url = url.replace(/か/g, "f");
            break;
          case "き":
            url = url.replace(/き/g, "g");
            break;
          case "く":
            url = url.replace(/く/g, "h");
            break;
          case "け":
            url = url.replace(/け/g, "i");
            break;
          case "こ":
            url = url.replace(/こ/g, "j");
            break;
          default:
        }
      }
      return Base64.decode(url);
    },
    // 获取专栏目录
    getCatalogueData(parent_id) {
      this.$api
        .get(this.catalogueUrl, {
          parent_id: parent_id,
        })
        .then((res) => {
          this.catalogueList = res.list;
          this.catalogueList.forEach((item, index) => {
            if (item.id == this.id) {
              this.catalogueActive = index;
            }
          });
        });
    },
    // 跳转其他课程
    toOtherCourse(name) {
      let type = this.catalogueList[name].type;
      let id = this.catalogueList[name].id;
      let path;
      if (type == this.type) {
        window.location.href = `${
          location.href.split("?")[0]
        }?id=${id}&type=${type}&channel=1`;
      } else {
        switch (type) {
          case 2:
            path = "/school/courseDetailsVideo";
            break;
          case 3:
            path = "/school/courseDetailsPicture";
            break;
          case 4:
            path = "/school/courseDetailsAudio";
            break;
          default:
          // console.log(type);
        }
        this.$router.push({
          path: path,
          query: {
            id: id,
            channel: 1,
            type: type,
          },
        });
      }
    },
    // 显示倍速，隐藏返回分享
    showRate() {
      this.isshowRate = true;
    },
    // 隐藏倍速
    hideRate() {
      this.isshowRate = false;
    },
    // 加入学习
    joinStudy() {
      if (this.isToken) {
        let courses_id;
        if (this.channel == 1) {
          courses_id = this.data.parent_id;
        } else {
          courses_id = this.id;
        }
        this.$api
          .post("school/member/add/study", {
            courses_id: courses_id,
          })
          .then((res) => {
            this.data.is_join_study = true;
            this.$refs.Videozj.updateProcess();
            if (this.channel == 1) {
              this.$toast("此专栏已成功加入学习");
            } else {
              this.$toast("此课程已成功加入学习");
            }
          });
      } else {
        this.$toast("下载客户端即可加入学习并且观看完整课程");
        if (this.isIOS) {
          window.location.href =
            "http://itunes.apple.com/cn/app/id1273703378?ls=1&mt=8";
        } else {
          this.$router.push("/school/load");
        }
      }
    },
    // 收藏
    collect(type) {
      if (type) {
        this.$api
          .post("school/member/add/collection", {
            courses_id: this.id,
          })
          .then((res) => {
            this.$toast("收藏成功！");
            this.data.is_collection = true;
          });
      } else {
        this.$api
          .post("school/member/cancel/collection", {
            courses_ids: [this.id],
          })
          .then((res) => {
            this.$toast("取消成功！");
            this.data.is_collection = false;
          });
      }
    },
    // 关注
    attention(lecturer_id) {
      this.$api
        .post("school/member/add/fans", {
          lecturer_id: lecturer_id,
        })
        .then((res) => {
          this.data.is_fans = true;
          this.$toast("关注成功！");
        });
    },
    // 进入讲师详情
    toLecturerDetail(id) {
      this.$router.push({
        path: "/school/lecturerDetails",
        query: {
          id: id,
        },
      });
    },
    // 暂停
    suspend(data) {
      // console.log("暂停");
    },
    // 预览
    fileView(url, title) {
      this.$router.push({
        path: "/school/filePreview",
        query: {
          url: `https://view.xdocin.com/xdoc?_xdoc=${url}`,
          title: title,
        },
      });
    },
    // 获取会员手机号
    getMobile() {
      this.$api.get("school/member/share/mobile").then((res) => {
        this.mobile = res.mobile;
      });
    },
    share() {
      if (
        (this.data.package_type == 3 &&
          this.data.special_column.all_role == 1) ||
        (this.data.package_type != 3 && this.data.all_role == 1)
      ) {
        // 全部用户
        this.$api.post("school/index/business/school/get/share").then((res) => {
          let title = res.small_title;
          let bigTitle = this.data.title;
          let thumb = res.image;
          let url = `${location.href}&mobile=${this.mobile}`;
          let paramAndroid = [bigTitle, title, url, thumb];
          let paramIos = [title, bigTitle, url, thumb];
          this.params(paramIos, JSON.stringify(paramAndroid), "toShare");
        });
      } else {
        // 指定用户
        this.$toast("该课程非公开，不支持分享哦~");
      }
    },
    // 广告跳转
    adSkip(data) {
      // console.log(data);
      switch (data.advertising_type) {
        case 1:
          // 商品广告
          let goodsHref = `xblife://home/goods_detail?goods_id=${data.shop_id}`;
          this.params(goodsHref, goodsHref, "goAdGoodsDetails");
          break;
        case 2:
          // 店铺广告
          let shopHref = `xblife://home/normal_shop_detail?shop_id=${data.shop_id}&type=${data.type}`;
          this.params(shopHref, shopHref, "goAdShopDetails");
          break;
        case 3:
          // 原生广告
          this.params(data.href, data.href, "goAdAppPage");
          break;
        case 5:
          // 展示型广告
          break;
        default:
          // 4 h5广告; 6 商学院广告
          // window.location.href = data.href;
          this.$router.push({
            path: "/school/tripartiteLink",
            query: {
              url: data.href,
            },
          });
      }
    },
    // 跳转到专栏
    toSpecial(id) {
      this.$router.push({
        path: "/school/courseDetailsSpecial",
        query: {
          id: id,
          channel: 2,
        },
      });
    },
    // 重定义三方地址
    replayAMethod(e) {
      let content = document.getElementById("content");
      //获取v-html中的所有a标签，返回一个类数组
      let aList = content.getElementsByTagName("a");
      aList = Array.from(aList);
      aList.forEach((item, i) => {
        // 阻止自动跳转
        item.onclick = (e) => {
          if (e && e.preventDefault) {
            //阻止默认浏览器动作(W3C)
            e.preventDefault();
          } else {
            //IE中阻止函数器默认动作的方式
            window.event.returnValue = false;
            return false;
          }
          let url = item.getAttribute("href");
          // 跳转至指定页面
          this.$router.push({
            path: "/school/tripartiteLink",
            query: {
              url: url,
            },
          });
        };
      });
    },
  },
};
</script>

<style>
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.loading img {
  width: 80px;
  height: 80px;
  margin: 200px 0 0;
}
.loading p {
  font-size: 12px;
  color: #9ca1ad;
}

.courseDetailsVideo {
  width: 100%;
  height: 100%;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  position: absolute;
  left: 0;
  top: 0;
}
.courseDetailsVideoTop {
  position: relative;
  background-color: black;
  padding-top: 38px;
}
.courseDetailsVideoTopNoData {
  background-color: #ffffff;
}
.courseDetailsVideoNav {
  color: #404247;
  width: 100%;
  height: 22px;
  padding-bottom: 11px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 43px;
  left: 0;
  z-index: 1001;
}
.courseDetailsVideoNav .navLeft {
  width: 24px;
  height: 24px;
  margin-left: 16px;
}
.courseDetailsVideoNav .navRight {
  display: flex;
  align-items: flex-end;
  margin-right: 16px;
}
.courseDetailsVideoNav .navRight img {
  width: 24px;
  height: 24px;
  margin-left: 24px;
}
.courseDetailsVideoNav .navRight .kj {
  width: 24px;
  height: 24px;
}
.courseDetailsVideoNav .navRight .sf {
  width: 40px;
  height: 31px;
  margin-left: 8px;
}
/* 标题 */
.titleTop {
  background: url("./../../../assets/school/coursebg.png") no-repeat 0 0;
  background-size: cover;
  padding: 16px;
}
.titleTop h3 {
  margin: 0;
  font-size: 18px;
  color: #404247;
}
.titleTop p {
  font-size: 12px;
  color: #6e727a;
  margin-top: 8px;
}
/* 内容 */
.courseDetailsVideo .van-tab--active {
  font-weight: 700;
}
.van-tabs__line {
  background: linear-gradient(90deg, #4e7df7 0%, #86b4fc 100%);
  bottom: 19px;
}
.courseDetailsVideo .van-tabs__wrap {
  display: flex;
  justify-content: center;
  background-color: #ffffff;
}
.courseDetailsVideo .van-tabs__nav {
  width: 120px;
}
.courseDetailsVideo .van-tab {
  flex: 1;
  font-size: 15px;
}

/* 简介 */
.courseDetailsVideo .dec {
  margin-top: 0px;
}
/* 已加入学习中心 */
.courseDetailsVideo .joinStudyZl {
  margin: 10px 0 24px;
}
.joinStudyZl h3 {
  color: #404247;
  font-size: 14px;
  margin: 0 16px 12px;
}
.joinStudyZl .van-tabs--line .van-tabs__wrap {
  height: 77px;
}
.joinStudyZl .van-tabs__nav {
  width: 100%;
}
.joinStudyZl .van-tab {
  flex: none;
  width: 185px;
  margin: 0 5px;
  background: #f6f8fd;
  border-radius: 8px;
}
.joinStudyZl .van-tabs__nav--line.van-tabs__nav--complete {
  padding: 0;
}
.joinStudyZl .van-tab .van-tab__text {
  display: block;
  width: 100%;
  height: 100%;
}
.joinStudyZlItem {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 56px;
  margin-top: 10px;
}
.joinStudyZlItem > div {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
}
.joinStudyZlItem > div img {
  width: 12px;
  height: 12px;
  margin-right: 4px;
}
.joinStudyZlItem p {
  font-size: 13px;
  font-weight: 500;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}
/* ad */
.courseDetailsVideo .ad {
  margin: 24px 16px 0;
  height: 72px;
  border-radius: 4px;
  overflow: hidden;
}
.dec .ad img {
  width: 100%;
  height: 100%;
}
.decMid {
  margin: 20px 16px 24px;
  color: #404247;
}
.decMid p {
  word-break: break-all;
  font-size: 15px;
  line-height: 25px;
}
.decBom {
  /* margin: 0 16px; */
}
.courseDetailsVideo .lecturerInfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  background-color: #f6f8fd;
  border-radius: 8px;
  margin: 24px 16px 0px;
  padding: 0 16px;
}
.decBom .lecturerInfo .head_pic {
  background-color: #ffffff;
}
.decBom .lecturerInfo img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
}
.decBom .lecturerInfo h3 {
  font-size: 15px;
  font-weight: 700;
  color: #404247;
  margin: 0;
}
.decBom .lecturerInfo p {
  font-size: 12px;
  color: #9ca1ad;
  margin: 4px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}
.decBom .lecturerInfo .lecturerInfoMid {
  flex: 1;
  margin: 0 8px;
}
.decBom .lecturerInfo .lecturerInfoAttention {
  width: 80px;
  height: 30px;
  background-color: #ffffff;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  color: #4e7df7;
  font-size: 13px;
}
.decBom .lecturerInfo div img {
  width: 12px;
  height: 12px;
  margin-right: 4px;
}
.courseDetailsVideo .zl {
  margin: 24px 16px;
}
.decBom .zl h3 {
  color: #404247;
  font-size: 15px;
}
.decBom .zl div {
  height: 72px;
  background-color: #f6f8fd;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.decBom .zl div img {
  width: 70px;
  height: 48px;
  border-radius: 4px;
}
.decBom .zl div p {
  color: #404247;
  line-height: 20px;
  font-size: 14px;
  margin-left: 8px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}

.btmdiv {
  width: 100%;
  height: 83px;
  background: #ffffff;
  box-shadow: 10px 0px 1px 1px #eeeeee;
  position: fixed;
  left: 0;
  bottom: 0;
}
.btmdiv span {
  margin: 4px 16px 0;
  display: block;
  height: 46px;
  line-height: 46px;
  text-align: center;
  background: linear-gradient(90deg, #f6e7b9 0%, #e4c083 100%);
  border-radius: 25px;
  font-size: 15px;
  font-weight: 700;
  color: #94692a;
}

/* 弹窗 */
.downloadOut {
  margin: 16px 16px 50px;
}
.downloadOut h3 {
  margin: 0px;
  padding-bottom: 16px;
  font-size: 16px;
  color: #404247;
  border-bottom: 1px solid #edf1fa;
}
.downloadItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;
}
.downloadItem img {
  width: 32px;
  height: 32px;
}
.downloadItem p {
  color: #404247;
  flex: 1;
  margin: 0 5px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}
.downloadItem span {
  width: 62px;
  height: 30px;
  line-height: 30px;
  font-size: 13px;
  text-align: center;
  background: rgba(78, 125, 247, 0.1);
  border-radius: 16px;
  color: #4e7df7;
}
.goHome {
  width: 82px;
  height: 32px;
  position: fixed;
  right: 0;
  bottom: 161px;
}

.noPower {
  margin: 0 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.noPower img {
  width: 235px;
  height: 235px;
}
.noPower p {
  margin-top: 24px;
  font-size: 14px;
  color: #9ca1ad;
}

.isIosxVideoOut .courseDetailsVideoTop {
  padding-top: 44px;
}
.isIosxVideoOut .courseDetailsVideoNav {
  top: 50px;
}
.noAppNav .courseDetailsVideoTop {
  padding-top: 15px !important;
}
.noAppNav .courseDetailsVideoNav {
  top: 10px;
}
.shareTip {
  position: fixed;
  top: 7px;
  right: 0;
  padding: 8px 16px 8px 24px;
  background: rgba(14, 14, 14, 0.36);
  border-radius: 18px 0px 0px 18px;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  z-index: 999;
}
</style>